<template>
  <div class="bg-white rounded-sm mx-3 my-3">
    <b-row>
      <b-col cols="12" class="mt-3">
        <b-row class="mx-1">
          <b-col cols="11">
            <span class="title mx-1">Copyright Registry File</span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mx-3 mt-2">
      <b-col cols="12" class="mx-auto bg-header_grey py-3 rounded">
        <span class="cursor-pointer text-blue hover:text-blue-dark hover:underline" @click="back">Back</span> 
        <span class="mx-3 text-gray">Copyright / {{trackingNumber}}</span>
      </b-col>
    </b-row>
    <b-row class="mx-3 mt-2">
      <b-col cols="12" class="py-4">
        <CopyrightDetails :tracking-number="trackingNumber" v-if="trackingNumber"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CopyrightDetails from "@/views/home/services/copyright/submissions/CopyrightDetails.vue";
import router from "@/router";

export default {
  name: "CopyrightFileWrapper",
  components: { CopyrightDetails },
  data() {
    return {
      trackingNumber: null
    };
  },
  mounted() {
    this.trackingNumber = this.$route.params.id;
  },
  methods: {
    back() {
      router.push({name: "copyright-registry"});
    }
  }
};
</script>

<style scoped>
</style>
